<template>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
                      style="min-height: 300px"
                      pulling-text="下拉重新获取数据"
                      loosing-text="释放即可重新加载"
                      loading-text=""
                      success-text="数据获取成功">
        <div :style="{minHeight: screeHeight + 'px'}">
            <van-tabs v-model="active" sticky title-active-color="#ee0a24" @change="onChange">
                <van-tab>
                    <div slot="title"><h3>新人上手</h3></div>
                    <Wp_mini_guide_new_member></Wp_mini_guide_new_member>
                </van-tab>
                <van-tab>
                    <div slot="title"><h3>赚钱教程</h3></div>
                    <div style="padding: 5px;">
                        <!--                    <Wp_mini_guide_earn_course></Wp_mini_guide_earn_course>-->
                        <Wp_jd_article cid="course"></Wp_jd_article>
                    </div>
                </van-tab>
                <van-tab>
                    <div slot="title"><h3>分享素材</h3></div>
                    <Wp_mini_guide_share_page></Wp_mini_guide_share_page>
    <!--                <div style="padding: 20px; text-align: center">-->
    <!--                    <h2>功能升级中，敬请期待</h2>-->
    <!--                </div>-->
                </van-tab>
            </van-tabs>

            <div style="padding-top: 15px">
                <van-divider style="padding: 0px; padding: 0px 16px; color: #aaaaaa; border-color: #aaaaaa">下拉刷新页面</van-divider>
            </div>
        </div>
    </van-pull-refresh>
</template>

<script>
    import Wp_mini_guide_new_member from "./Wp_mini_guide_new_member";
    import Wp_jd_article from "../pages_childs/Wp_jd_article";
    import Wp_mini_guide_share_page from "./Wp_mini_guide_share_page";
    export default {
        name: "Wp_mini_guide",
        components: {Wp_mini_guide_share_page, Wp_jd_article, Wp_mini_guide_new_member},
        provide(){
            return{
                wp_mini_guide : this
            }

        },
        data() {
            return {
                active: 0,
                isLoading: false,
                screeHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
            }
        },
        created(){
            if(this.$common.is_from_article_content && this.$common.is_from_article_content === "true"){
                this.active = 1;
                this.$common.is_from_article_content = "";
            }
        },
        methods: {
            /**
             * 下拉刷新
             */
            onRefresh() {
                this.isLoading =false;
                window.location.reload();
            },

            onChange(v) {
                this.$log(v);
                this.active = v;
            }
        },

    }
</script>

<style scoped>

</style>